import React, { memo } from 'react'
import DeleteIcon from 'transfix-icons/build/DeleteIcon'
import { IconButton } from 'transfix-ui/components/IconButton'
import { IVin } from 'types/carrier'

interface ISingleVinProps {
  vin: IVin
  deleteVin?: (vin: IVin) => void
}

export const SingleVin = memo<ISingleVinProps>(({ deleteVin, vin }) => {
  const handleDelete = () => deleteVin!(vin)
  const { vin: label } = vin

  return (
    <span data-test={`${label}-id`}>
      <div className='ph1'>{label}</div>
      {deleteVin && (
        <IconButton
          Icon={DeleteIcon}
          color='tertiary'
          onClick={handleDelete}
          data-test='delete-vin-button'
          label='Delete VIN'
          size='large'
        />
      )}
    </span>
  )
})
